import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import ResourceCategoryService from "../../src/Services/ResourceCategory.service";
const ResourceCategoryLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "name",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<ResourceCategory[]>' is not assignable to type '(ids: string[]) => Promise<ResourceCategory[]>'.
        fetchItemsById: (ids) => {
            return ResourceCategoryService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return ResourceCategoryService.searchAll(search);
        },
        optionRenderer: function optionRenderer(resourceCategory) {
            return _jsx("span", { children: resourceCategory.name });
        },
    });
};
export default ResourceCategoryLookup;
